import createReadonlyDictionary from "stores/templates/ReadonlyDictionaryStore";
import api from "services/api";

const WorkoutTypeDictionary = createReadonlyDictionary({
  fetch: async function() {
    return await api.get(`/workout/type/list`);
  },
});

export default WorkoutTypeDictionary.create();
